import { useState, useEffect, useRef } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function MensagemWhatsapp() {
  const { isAdmin } = useAuth()
  const navigate = useNavigate()
  const [gestores, setGestores] = useState([])
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState([])
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)
  const [result, setResult] = useState(null)
  const sendingRef = useRef(false)

  useEffect(() => {
    if (!isAdmin) { navigate('/'); return }
    fetchGestores()
  }, [isAdmin])

  async function fetchGestores() {
    setLoading(true)
    const { data } = await supabase
      .from('profiles')
      .select('id, nome, cargo, whatsapp, role')
      .not('whatsapp', 'is', null)
      .neq('whatsapp', '')
      .order('nome')
    setGestores(data || [])
    setLoading(false)
  }

  function toggleSelect(id) {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
  }

  function toggleAll() {
    setSelected(selected.length === gestores.length ? [] : gestores.map(g => g.id))
  }

  async function handleSend() {
    if (sendingRef.current || !selected.length || !message.trim()) return
    sendingRef.current = true
    setSending(true)
    setResult(null)

    try {
      const { data, error } = await supabase.functions.invoke('enviar-whatsapp', {
        body: { profileIds: selected, message },
      })
      if (error) throw error
      setResult(data)
    } catch (e) {
      setResult({ ok: false, erros: [e.message] })
    }

    setSending(false)
    sendingRef.current = false
  }

  return (
    <div>
      <div className="page-title">
        <div>
          <h2>Mensagem WhatsApp</h2>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 2 }}>
            Envie uma mensagem para gestores selecionados
          </p>
        </div>
      </div>

      {result && (
        <div className="alert" style={{
          marginBottom: 16,
          background: result.ok ? 'var(--green-bg)' : 'var(--red-bg)',
          color: result.ok ? 'var(--green)' : 'var(--red)',
          borderLeft: `3px solid ${result.ok ? 'var(--green)' : 'var(--red)'}`,
        }}>
          {result.ok
            ? `${result.enviados} mensagem(ns) enviada(s) com sucesso.`
            : `Erro ao enviar: ${result.erros?.join(' | ')}`}
        </div>
      )}

      {/* Destinatários */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ margin: 0 }}>Destinatários</h3>
          {gestores.length > 0 && (
            <button className="btn btn-sm btn-ghost" onClick={toggleAll}>
              {selected.length === gestores.length ? 'Desmarcar todos' : 'Selecionar todos'}
            </button>
          )}
        </div>

        {loading ? (
          <div style={{ color: 'var(--text3)', fontSize: 13 }}>Carregando...</div>
        ) : gestores.length === 0 ? (
          <div className="empty-state" style={{ padding: '20px 0' }}>
            Nenhum gestor com WhatsApp cadastrado.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {gestores.map(g => (
              <div
                key={g.id}
                onClick={() => toggleSelect(g.id)}
                style={{
                  display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 12,
                  padding: '12px', borderRadius: 8, cursor: 'pointer',
                  border: `1px solid ${selected.includes(g.id) ? 'var(--blue-border)' : '#e2e0d8'}`,
                  background: selected.includes(g.id) ? 'var(--blue-bg)' : 'transparent',
                  transition: 'all 0.15s',
                }}
              >
                <input
                  type="checkbox"
                  checked={selected.includes(g.id)}
                  onChange={() => toggleSelect(g.id)}
                  onClick={e => e.stopPropagation()}
                  style={{ accentColor: 'var(--blue)', margin: 0, width: 16, height: 16, flexShrink: 0 }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                    <span style={{ fontWeight: 600, fontSize: 13 }}>{g.nome}</span>
                    <span className={`badge ${g.role === 'admin' ? 'badge-blue' : 'badge-gray'}`}>
                      {g.role === 'admin' ? 'Admin' : 'Gestor'}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                    {g.cargo ? `${g.cargo} · ` : ''}{g.whatsapp}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Mensagem */}
      <div className="card">
        <h3 style={{ margin: '0 0 14px' }}>Mensagem</h3>
        <textarea
          value={message}
          onChange={e => { setMessage(e.target.value); setResult(null) }}
          placeholder="Digite a mensagem que será enviada via WhatsApp..."
          rows={6}
          style={{ width: '100%', resize: 'vertical', fontSize: 13, boxSizing: 'border-box' }}
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
          <button
            className="btn btn-primary"
            onClick={handleSend}
            disabled={sending || !selected.length || !message.trim()}
          >
            {sending ? 'Enviando...' : `Enviar para ${selected.length || 0} gestor${selected.length === 1 ? '' : 'es'}`}
          </button>
          {!selected.length && (
            <span style={{ fontSize: 12, color: 'var(--text3)' }}>
              Selecione ao menos um destinatário acima
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
